module.exports = __webpack_public_path__ + "img/mesa_ls03m.b1d791df.png";